import React, { memo, useRef } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import {Navigation} from "swiper";
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import * as TYPES from '../../models/types';

import 'swiper/css';
import "swiper/css/pagination";
import "swiper/css/navigation";
import styles from './styles.module.scss';

const Index = memo(() => {

  const dispatch = useDispatch();
  const { handleViwerEvent } = actions;

  const { home: {casesInfo} } = useSelector(({localesReducer}) => localesReducer.i18n);
  const viewrSliceReducer = useSelector(({viewrSliceReducer}) => viewrSliceReducer);
  const activeNewIndex = useRef(0);

  const viwerSwiper = () => {
    return (
      <Swiper
        initialSlide={activeNewIndex.current}
        slidesPerView={1}
        loop={true}
        pagination={{
          clickable: false, // 打开自定义按钮控制事件上一个和下一个
        }}
        effect="cube"
        speed={1000}
        aria-grabbed
        watchSlidesProgress
        mousewheel
        keyboard
        spaceBetween={0}
        centeredSlides={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
       
        onTouchStart={(swiper) => {
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = '';
          }
        }}
        onSetTransition={(swiper, speed) => {
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = speed + 'ms';
          }
        }}
        navigation={{
          prevEl: '.swiperbuttonprev',
          nextEl: '.swiperbuttonnext',
        }}
        modules={[Navigation]}
        className="viwerSwiper"
        onInit={(swiper) => {
          handleSwiperMethods(swiper);
        }}
        onSlideChange={(swiper) => {
          activeNewIndex.current = swiper.activeIndex;
        }}
       
      >
        {casesInfo.list.map(item => (
           <SwiperSlide key={item.id}>
            <img src={item.img} alt='' />
          </SwiperSlide>
        ))}
      </Swiper>
    )
  }

  const handleSwiperMethods = (swiper) => {
    activeNewIndex.current = viewrSliceReducer.activeIndex+1;
    swiper.slideTo(activeNewIndex.current);
  }

  const handleClose = () => {
    dispatch(handleViwerEvent({visible: TYPES.VIWERSCLOSE, activeIndex: 0}));
  }

  return (
      <div className={styles.normal}>
        <div className='content'>
            <div className="close" onClick={handleClose}>
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M7.7072 7.70711C7.89474 7.51957 8.22631 7.49143 8.62897 7.62887C9.03163 7.76632 9.47239 8.05809 9.85431 8.44L40.0943 38.68C40.4762 39.0619 40.768 39.5027 40.9054 39.9053C41.0429 40.308 41.0147 40.6396 40.8272 40.8271C40.6397 41.0146 40.3081 41.0428 39.9054 40.9053C39.5028 40.7679 39.062 40.4761 38.6801 40.0942L8.44009 9.85421C8.05818 9.4723 7.76641 9.03153 7.62897 8.62887C7.49152 8.22621 7.51966 7.89464 7.7072 7.70711Z" fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M41.1214 7.70711C40.9339 7.51957 40.6023 7.49143 40.1996 7.62887C39.797 7.76632 39.3562 8.05809 38.9743 8.44L8.73431 38.68C8.35239 39.0619 8.06062 39.5027 7.92318 39.9053C7.78574 40.308 7.81388 40.6396 8.00141 40.8271C8.18895 41.0146 8.52052 41.0428 8.92318 40.9053C9.32584 40.7679 9.76661 40.4761 10.1485 40.0942L40.3885 9.85421C40.7704 9.4723 41.0622 9.03153 41.1996 8.62887C41.3371 8.22621 41.3089 7.89464 41.1214 7.70711Z" fill="white"/>
              </svg>
            </div>
            {viwerSwiper()}
            <div className="swiperbuttonprev">
              <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30.5 17L18.5 26L30.5 35" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <rect x="-1" y="1" width="50" height="50" rx="25" transform="matrix(-1 0 0 1 50 0)" stroke="white" strokeWidth="2"/>
              </svg>
            </div>
            <div className="swiperbuttonnext">
              <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.5 17L33.5 26L21.5 35" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <rect x="1" y="1" width="50" height="50" rx="25" stroke="white" strokeWidth="2"/>
              </svg>
            </div>
        </div>
      </div>
  );
});
export default Index;
